<template>
  <div>
    <el-row class="margin-top-lg">
      <el-col :span="2" >
        <el-select v-model="simplifyRoomFeeInfo.feeTypeCd" @change="changeSimplifyRoomFeeFeeTypeCd" size="small"
          :placeholder="$t('simplifyRoomFee.selectFeeType')">
          <template v-for="item in simplifyRoomFeeInfo.feeTypeCds">
            <el-option :key="item.statusCd" :label="item.name" :value="item.statusCd"
              v-if="item.statusCd != '888800010008'"></el-option>
          </template>
        </el-select>
      </el-col>
      <el-col :span="2" >
        <el-select v-model="simplifyRoomFeeInfo.configId" @change="changeSimplifyRoomConfigId" size="small"
          :placeholder="$t('simplifyRoomFee.selectFeeItem')">
          <el-option v-for="item in simplifyRoomFeeInfo.feeConfigs" :key="item.configId" :label="item.feeName"
            :value="item.configId"></el-option>
        </el-select>
      </el-col>
      <el-col :span="2" >
        <el-select v-model="simplifyRoomFeeInfo.state" @change="changeSimplifyRoomConfigId" size="small"
          :placeholder="$t('simplifyRoomFee.selectStatus')">
          <el-option :label="$t('simplifyRoomFee.valid')" value="2008001"></el-option>
          <el-option :label="$t('simplifyRoomFee.feeEnd')" value="2009001"></el-option>
        </el-select>
      </el-col>
      <el-col :span="2" >
        <el-select v-model="simplifyRoomFeeInfo.ownerFee" @change="changeSimplifyRoomConfigId" size="small">
          <el-option :label="$t('simplifyRoomFee.currentRoom')" value="N"></el-option>
          <el-option :label="$t('simplifyRoomFee.currentOwner')" value="Y"></el-option>
        </el-select>
      </el-col>
      <el-col :span="2" v-if="simplifyRoomFeeInfo.roomId && simplifyRoomFeeInfo.state == '2008001'">
        <el-select v-model="simplifyRoomFeeInfo.showFlag" @change="changeSimplifyRoomShowFlag" size="small">
          <el-option :label="$t('simplifyRoomFee.default')" value="DEFAULT"></el-option>
          <el-option :label="$t('simplifyRoomFee.monthly')" value="MONTH"></el-option>
        </el-select>
      </el-col>
      <el-col :span="2" v-else></el-col>
      <el-col :span="13" class="text-right">
        <el-button type="primary" size="small" v-if="hasPrivilege('502020082314267912')"
          @click="openBatchPayRoomFeeModal">
          <i class="el-icon-plus"></i>
          {{ $t('simplifyRoomFee.batchPayment') }}
        </el-button>
        <el-button type="primary" size="small" v-if="hasPrivilege('502022073007100003')"
          @click="openTempImportRoomFeeModal">
          <i class="el-icon-plus"></i>
          {{ $t('simplifyRoomFee.tempFee') }}
        </el-button>
        <el-button type="primary" size="small" v-if="hasPrivilege('502022073049300004')" @click="openProxyFeeModal">
          <i class="el-icon-plus"></i>
          {{ $t('simplifyRoomFee.quantityPayment') }}
        </el-button>
        <el-button type="primary" size="small" v-if="hasPrivilege('502022073042960005')"
          @click="openAddMeterWaterSimplifyModal">
          <i class="el-icon-plus"></i>
          {{ $t('simplifyRoomFee.waterElectricity') }}
        </el-button>
        <el-button type="primary" size="small" v-if="hasPrivilege('502022073006890006')"
          @click="openRoomCreateFeeComboModal">
          <i class="el-icon-plus"></i>
          {{ $t('simplifyRoomFee.feePackage') }}
        </el-button>
        <el-button type="primary" size="small" v-if="hasPrivilege('502022073096990007')"
          @click="openRoomCreateFeeAddModal">
          <i class="el-icon-plus"></i>
          {{ $t('simplifyRoomFee.createFee') }}
        </el-button>
        <el-button type="primary" size="small" v-if="hasPrivilege('502020080570210194')" @click="toOwnerPayFee">
          <i class="el-icon-plus"></i>
          {{ $t('simplifyRoomFee.arrearsPayment') }}
        </el-button>
      </el-col>
    </el-row>
    <!-- 切换按钮 + 批量操作 + 展开收起  create by cht at 2026/6/13 11:50 -->
    <el-row class="margin-top margin-bottom">
      <el-col :span="24" class="flex align-center justify-between">
        <!-- 左侧：平铺展示/分组展示切换 + 统计 -->
        <div class="flex align-center">
          <el-radio-group v-model="displayMode" size="small">
            <el-radio-button label="1">{{ $t('simplifyRoomFee.flatMode') }}</el-radio-button>
            <el-radio-button label="2">{{ $t('simplifyRoomFee.groupingMode') }}</el-radio-button>
          </el-radio-group>
          <span class="fee-summary margin-left">
          本页共有 {{ uniqueFeeCount }} 种费用项，{{ simplifyRoomFeeInfo.fees.length }} 笔账单
        </span>
        </div>

        <!-- 右侧：展开收起(仅分组模式)+ 批量操作(有选中时显示) -->
        <div class="flex align-center">
          <!-- 分组模式才显示展开全部/收起全部 -->
          <template v-if="displayMode === '2'">
            <el-button type="primary" size="small" plain @click="expandAllGroups">{{ $t('simplifyRoomFee.expandAll') }}</el-button>
            <el-button type="primary" size="small" plain @click="collapseAllGroups">{{ $t('simplifyRoomFee.collapseAll') }}</el-button>
          </template>

          <!-- 批量取消费用/批量结束费用,批量操作按钮(如果想要有选中才显示的效果,就在template后加上 v-if="hasBatchSelection") -->
          <template>
            <el-button type="danger" size="small"
                       v-if="hasPrivilege('502020090604200029')"
                       @click="batchDeleteFee">{{ $t('simplifyRoomFee.batchDeleteFee') }}</el-button>
            <el-button type="warning" size="small"
                       v-if="hasPrivilege('502021070488970005')"
                       @click="batchFinishFee">{{ $t('simplifyRoomFee.batchFinishFee') }}</el-button>
          </template>
        </div>
    </el-col>
  </el-row>
    <!-- 以上切换按钮 create by cht at 2026/6/10 10:15    -->

    <!--  (平铺展示)将v-show="simplifyRoomFeeInfo.showFlag == 'DEFAULT'"改为v-if动态切换  create by cht at 2026/6/10 10:20 -->
    <div class="margin-top" v-if="displayMode === '1' && simplifyRoomFeeInfo.showFlag == 'DEFAULT'">
      <el-table :data="simplifyRoomFeeInfo.fees" style="width: 100%" border stripe
                ref="flatTable"
                @selection-change="handleFlatSelectionChange">    <!-- 新增flatTable和绑定方法handleFlatSelectionChange   create by cht at 2026/6/13 9:50 -->
        <!-- 新增选择列 create by cht at 2026/6/13 9:50 -->
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column prop="feeName" :label="$t('simplifyRoomFee.feeItem')" align="center">
          <template slot-scope="scope">
            <span class="hand" @click="viewRoomFeeConfig(scope.row)">
              {{ scope.row.feeName }}{{ getSimplifyRoomFeeRoomName(scope.row) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="feeFlagName" :label="$t('simplifyRoomFee.feeFlag')" align="center"></el-table-column>
        <el-table-column prop="feeTypeCdName" :label="$t('simplifyRoomFee.feeType')" align="center"></el-table-column>
        <el-table-column prop="amountOwed" :label="$t('simplifyRoomFee.receivableAmount')"
          align="center"></el-table-column>
        <el-table-column :label="$t('simplifyRoomFee.accountTime')" align="center">
          <template slot-scope="scope">
            {{ scope.row.startTime }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('simplifyRoomFee.receivablePeriod')" align="center">
          <template slot-scope="scope">
            {{ getEndTime(scope.row) }}~<br />{{ getDeadlineTime(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('simplifyRoomFee.description')" align="center" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
              <span>{{ $t('simplifyRoomFee.preDegrees') }}</span>{{ scope.row.preDegrees }}
            </div>
            <div v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
              <span>{{ $t('simplifyRoomFee.curDegrees') }}</span>{{ scope.row.curDegrees }}
            </div>
            <!-- 电费则展示算费系数 create by cht at 2026/7/9 11:15 -->
            <div v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
              <div v-if="scope.row.feeTypeCd == '888800010016'">
                <span>{{ $t('simplifyRoomFee.feeCoefficient') }}</span>{{ scope.row.feeCoefficient }}
              </div>
            </div>
            <div v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
              <span>{{ $t('simplifyRoomFee.unitPrice') }}</span>{{ getOnePrice1(scope.row) }}
            </div>
            <div v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
              <span>{{ $t('simplifyRoomFee.additionalFee') }}</span>{{ scope.row.additionalAmount }}
            </div>
            <div v-else-if="scope.row.computingFormula == '6006'">
              <span>{{ $t('simplifyRoomFee.usage') }}</span>{{ getAttrValue(scope.row.feeAttrs, '390006') }}
            </div>
            <div v-else-if="scope.row.computingFormula == '6006'">
              <span>{{ $t('simplifyRoomFee.unitPrice') }}</span>{{ scope.row.squarePrice }}
            </div>
            <div v-else-if="scope.row.computingFormula == '6006'">
              <span>{{ $t('simplifyRoomFee.additionalFee') }}</span>{{ scope.row.additionalAmount }}
            </div>
            <div v-else-if="scope.row.feeTypeCd == '888800010017'">
              <span>{{ $t('simplifyRoomFee.algorithm') }}</span>{{ getAttrValue(scope.row.feeAttrs, '390005') }}
            </div>
            <div v-else-if="scope.row.feeTypeCd == '888800010017'">
              <span>{{ $t('simplifyRoomFee.usage') }}</span>{{ getAttrValue(scope.row.feeAttrs, '390003') }}
            </div>
            <div v-else>
              <span>{{ $t('simplifyRoomFee.unitPrice') }}</span>{{ scope.row.squarePrice }}
            </div>
            <div v-if="scope.row.feeFlag == '1003006'">
              <span>{{ $t('simplifyRoomFee.additionalFee') }}</span>{{ scope.row.additionalAmount }}
            </div>
            <div v-else>
              <span>{{ $t('simplifyRoomFee.fixedFee') }}</span>{{ scope.row.additionalAmount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="stateName" :label="$t('simplifyRoomFee.status')" align="center"></el-table-column>
        <el-table-column :label="$t('simplifyRoomFee.operation')" align="center" width="200">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.row.state != '2009001' && hasPrivilege('502020082314267912')"
              @click="payFee(scope.row)">
              {{ $t('simplifyRoomFee.payment') }}
            </el-button>
            <el-button type="text" @click="payFeeHis(scope.row)">
              {{ $t('simplifyRoomFee.paymentHistory') }}
            </el-button>
            <el-dropdown
              v-if="hasPrivilege('502020090604200029') || hasPrivilege('502021070488970005') || hasPrivilege('502020090427190001')">
              <span class="el-dropdown-link">
                {{ $t('simplifyRoomFee.moreOperations') }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="hasPrivilege('502020090604200029')" @click.native="deleteFee(scope.row)">
                  {{ $t('simplifyRoomFee.cancelFee') }}
                </el-dropdown-item>
                <el-dropdown-item v-if="hasPrivilege('502021070488970005')" @click.native="finishFee(scope.row)">
                  {{ $t('simplifyRoomFee.manualEnd') }}
                </el-dropdown-item>
                <el-dropdown-item v-if="scope.row.state != '2009001' && hasPrivilege('502020090427190001')"
                  @click.native="editFee(scope.row)">
                  {{ $t('simplifyRoomFee.feeChange') }}
                </el-dropdown-item>
                <el-dropdown-item>
                  <a target="_blank" :href="'/#/views/fee/feeDetail?feeId=' + scope.row.feeId">
                    {{ $t('simplifyRoomFee.details') }}
                  </a>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next" :total="total" class="pagination text-right"></el-pagination>
    </div>

    <!-- (分组展示)按费用项收起费用 create by cht at 2026/6/9 16:40-->
    <div class="margin-top" v-if="displayMode === '2' && simplifyRoomFeeInfo.showFlag == 'DEFAULT'">
      <!-- 费用分组列表 -->
      <div class="fee-group-list">
        <div v-for="group in groupedFees" :key="group.configId" class="fee-group">

          <!-- 分组标题行(可点击折叠) update by cht at 2026/6/13 10:45 -->
          <div class="fee-group-header" :class="{ 'expanded': isGroupExpanded(group.configId) }">
            <!-- 左侧：checkbox复选框 + 费用项ID + 费用项名称 -->
            <div class="flex align-center" @click.stop="toggleGroup(group.configId)">
              <el-checkbox
                  v-model="groupSelectedConfigIds"
                  :label="group.configId"
                  @change="checked => toggleGroupConfig(group.configId, checked)"
                  @click.native.stop>  <!-- 阻止冒泡，点击checkbox不触发折叠(费用项ID要跟着复选框则加上:label="group.configId") -->
                &nbsp;
                </el-checkbox>
              <span class="fee-group-id">【{{ group.configId }}】</span>
              <span class="fee-group-name margin-left">{{ group.feeName }}</span>
            </div>
            <!-- 中间：统计信息 -->
            <span class="fee-group-meta" @click.stop="toggleGroup(group.configId)">
              {{ group.feeFlagName }} | {{ group.feeTypeCdName }} | 本页{{ group.count }}笔 | 本页{{ $t('simplifyRoomFee.arrearsSubtotal') }}{{ group.totalAmount.toFixed(2) }}元
              <span v-if="group.prepayAmount > 0" style="color: #67C23A; margin-left: 10px;">
                | 本页{{ $t('simplifyRoomFee.prepayableTotal') }}{{ group.prepayAmount.toFixed(2) }}元
              </span>
            </span>
            <!-- 右侧：展开/收起的箭头图标 -->
            <span class="expand-icon margin-right" @click.stop="toggleGroup(group.configId)"> <i :class="isGroupExpanded(group.configId) ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i> </span>
          </div>

          <!-- 分组内容(账单明细表格) -->
          <el-collapse-transition>
            <div v-show="isGroupExpanded(group.configId)" class="fee-group-content">
              <el-table :data="group.fees" style="width: 100%" border stripe size="small"
                        :ref="'groupTable_' + group.configId"
                        @selection-change="val => handleGroupFeeSelection(group.configId, val)">  <!-- 新增动态绑定groupTable且每组唯一、绑定方法handleGroupFeeSelection  create by cht at 2026/6/13 10:00 -->
                <!-- 新增勾选框列  create by cht at 2026/6/13 10:00 -->
                <el-table-column type="selection" width="55" align="center"></el-table-column>

                <el-table-column prop="feeName" :label="$t('simplifyRoomFee.feeItem')" align="center">
                  <template slot-scope="scope">
                <span class="hand" @click="viewRoomFeeConfig(scope.row)">
                  {{ scope.row.feeName }}{{ getSimplifyRoomFeeRoomName(scope.row) }}
                </span>
                  </template>
                </el-table-column>
                <el-table-column prop="feeFlagName" :label="$t('simplifyRoomFee.feeFlag')" align="center"></el-table-column>
                <el-table-column prop="feeTypeCdName" :label="$t('simplifyRoomFee.feeType')" align="center"></el-table-column>
                <el-table-column prop="amountOwed" :label="$t('simplifyRoomFee.receivableAmount')" align="center"></el-table-column>
                <el-table-column :label="$t('simplifyRoomFee.accountTime')" align="center">
                  <template slot-scope="scope">{{ scope.row.startTime }}</template>
                </el-table-column>
                <el-table-column :label="$t('simplifyRoomFee.receivablePeriod')" align="center">
                  <template slot-scope="scope">
                    {{ getEndTime(scope.row) }}~<br/>{{ getDeadlineTime(scope.row) }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('simplifyRoomFee.description')" align="center" width="150">
                  <template slot-scope="scope">
                    <div v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
                      <span>{{ $t('simplifyRoomFee.preDegrees') }}</span>{{ scope.row.preDegrees }}
                    </div>
                    <div v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
                      <span>{{ $t('simplifyRoomFee.curDegrees') }}</span>{{ scope.row.curDegrees }}
                    </div>
                    <!-- 电费则展示算费系数 create by cht at 2026/7/9 11:15 -->
                    <div v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
                      <div v-if="scope.row.feeTypeCd == '888800010016'">
                        <span>{{ $t('simplifyRoomFee.feeCoefficient') }}</span>{{ scope.row.feeCoefficient }}
                      </div>
                    </div>
                    <div v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
                      <span>{{ $t('simplifyRoomFee.unitPrice') }}</span>{{ getOnePrice1(scope.row) }}
                    </div>
                    <div v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
                      <span>{{ $t('simplifyRoomFee.additionalFee') }}</span>{{ scope.row.additionalAmount }}
                    </div>
                    <div v-else-if="scope.row.computingFormula == '6006'">
                      <span>{{ $t('simplifyRoomFee.usage') }}</span>{{ getAttrValue(scope.row.feeAttrs, '390006') }}
                    </div>
                    <div v-else-if="scope.row.computingFormula == '6006'">
                      <span>{{ $t('simplifyRoomFee.unitPrice') }}</span>{{ scope.row.squarePrice }}
                    </div>
                    <div v-else-if="scope.row.computingFormula == '6006'">
                      <span>{{ $t('simplifyRoomFee.additionalFee') }}</span>{{ scope.row.additionalAmount }}
                    </div>
                    <div v-else-if="scope.row.feeTypeCd == '888800010017'">
                      <span>{{ $t('simplifyRoomFee.algorithm') }}</span>{{ getAttrValue(scope.row.feeAttrs, '390005') }}
                    </div>
                    <div v-else-if="scope.row.feeTypeCd == '888800010017'">
                      <span>{{ $t('simplifyRoomFee.usage') }}</span>{{ getAttrValue(scope.row.feeAttrs, '390003') }}
                    </div>
                    <div v-else>
                      <span>{{ $t('simplifyRoomFee.unitPrice') }}</span>{{ scope.row.squarePrice }}
                    </div>
                    <div v-if="scope.row.feeFlag == '1003006'">
                      <span>{{ $t('simplifyRoomFee.additionalFee') }}</span>{{ scope.row.additionalAmount }}
                    </div>
                    <div v-else>
                      <span>{{ $t('simplifyRoomFee.fixedFee') }}</span>{{ scope.row.additionalAmount }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="stateName" :label="$t('simplifyRoomFee.status')" align="center"></el-table-column>
                <el-table-column :label="$t('simplifyRoomFee.operation')" align="center" width="200">
                  <template slot-scope="scope">
                    <el-button type="text" v-if="scope.row.state != '2009001' && hasPrivilege('502020082314267912')" @click="payFee(scope.row)">
                      {{ $t('simplifyRoomFee.payment') }}
                    </el-button>
                    <el-button type="text" @click="payFeeHis(scope.row)">
                      {{ $t('simplifyRoomFee.paymentHistory') }}
                    </el-button>
                    <el-dropdown v-if="hasPrivilege('502020090604200029') || hasPrivilege('502021070488970005') || hasPrivilege('502020090427190001')">
                  <span class="el-dropdown-link">
                    {{ $t('simplifyRoomFee.moreOperations') }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-if="hasPrivilege('502020090604200029')" @click.native="deleteFee(scope.row)">
                          {{ $t('simplifyRoomFee.cancelFee') }}
                        </el-dropdown-item>
                        <el-dropdown-item v-if="hasPrivilege('502021070488970005')" @click.native="finishFee(scope.row)">
                          {{ $t('simplifyRoomFee.manualEnd') }}
                        </el-dropdown-item>
                        <el-dropdown-item v-if="scope.row.state != '2009001' && hasPrivilege('502020090427190001')" @click.native="editFee(scope.row)">
                          {{ $t('simplifyRoomFee.feeChange') }}
                        </el-dropdown-item>
                        <el-dropdown-item>
                          <a target="_blank" :href="'/#/views/fee/feeDetail?feeId=' + scope.row.feeId">
                            {{ $t('simplifyRoomFee.details') }}
                          </a>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-collapse-transition>

        </div>
      </div>

      <!-- 分页 -->
      <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
                     layout="total, prev, pager, next" :total="total" class="pagination text-right"></el-pagination>
    </div>

    <div class="margin-top" v-show="simplifyRoomFeeInfo.showFlag == 'MONTH'">
      <el-table :data="simplifyRoomFeeInfo.monthFees" style="width: 100%" border stripe>
        <el-table-column prop="feeName" :label="$t('simplifyRoomFee.feeItem')" align="center">
          <template slot-scope="scope">
            <span class="hand" @click="viewRoomFeeConfig(scope.row)">
              {{ scope.row.feeName }}{{ getSimplifyRoomFeeRoomName(scope.row) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="feeFlagName" :label="$t('simplifyRoomFee.feeFlag')" align="center"></el-table-column>
        <el-table-column prop="feeTypeCdName" :label="$t('simplifyRoomFee.feeType')" align="center"></el-table-column>
        <el-table-column :label="$t('simplifyRoomFee.chargeYearMonth')" align="center">
          <template slot-scope="scope">
            {{ scope.row.detailYear }}-{{ scope.row.detailMonth }}
          </template>
        </el-table-column>
        <el-table-column prop="receivableAmount" :label="$t('simplifyRoomFee.receivableAmount')"
          align="center"></el-table-column>
        <el-table-column :label="$t('simplifyRoomFee.description')" align="center" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
              <span>{{ $t('simplifyRoomFee.preDegrees') }}</span>{{ scope.row.preDegrees }}
            </div>
            <div v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
              <span>{{ $t('simplifyRoomFee.curDegrees') }}</span>{{ scope.row.curDegrees }}
            </div>
            <div v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
              <span>{{ $t('simplifyRoomFee.unitPrice') }}</span>{{ getOnePrice1(scope.row) }}
            </div>
            <div v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
              <span>{{ $t('simplifyRoomFee.additionalFee') }}</span>{{ scope.row.additionalAmount }}
            </div>
            <div v-else-if="scope.row.computingFormula == '6006'">
              <span>{{ $t('simplifyRoomFee.usage') }}</span>{{ getAttrValue(scope.row.feeAttrs, '390006') }}
            </div>
            <div v-else-if="scope.row.computingFormula == '6006'">
              <span>{{ $t('simplifyRoomFee.unitPrice') }}</span>{{ scope.row.squarePrice }}
            </div>
            <div v-else-if="scope.row.computingFormula == '6006'">
              <span>{{ $t('simplifyRoomFee.additionalFee') }}</span>{{ scope.row.additionalAmount }}
            </div>
            <div v-else-if="scope.row.feeTypeCd == '888800010017'">
              <span>{{ $t('simplifyRoomFee.algorithm') }}</span>{{ getAttrValue(scope.row.feeAttrs, '390005') }}
            </div>
            <div v-else-if="scope.row.feeTypeCd == '888800010017'">
              <span>{{ $t('simplifyRoomFee.usage') }}</span>{{ getAttrValue(scope.row.feeAttrs, '390003') }}
            </div>
            <div v-else>
              <span>{{ $t('simplifyRoomFee.unitPrice') }}</span>{{ scope.row.squarePrice }}
            </div>
            <div v-if="scope.row.feeFlag == '1003006'">
              <span>{{ $t('simplifyRoomFee.additionalFee') }}</span>{{ scope.row.additionalAmount }}
            </div>
            <div v-else>
              <span>{{ $t('simplifyRoomFee.fixedFee') }}</span>{{ scope.row.additionalAmount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('simplifyRoomFee.operation')" align="center">
          <template slot-scope="scope">
            <a target="_blank" :href="'/#/views/fee/feeDetail?feeId=' + scope.row.feeId">
              {{ $t('simplifyRoomFee.details') }}
            </a>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-row>
      <el-col :span="12" class="text-left table-desc">
        <div>{{ $t('simplifyRoomFee.note1') }}</div>
        <div>{{ $t('simplifyRoomFee.note2') }}</div>
        <div>{{ $t('simplifyRoomFee.note3') }}</div>
        <div>{{ $t('simplifyRoomFee.note4') }}</div>
      </el-col>
      <el-col :span="12" class="text-right">
        <span>
          <span>本页{{ $t('simplifyRoomFee.arrearsSubtotal') }}</span>{{ simplifyRoomFeeInfo.totalAmount }}
          <!-- 区分欠费和可预缴金额  create by cht at 2026/6/10 17:50       -->
          <span v-if="simplifyRoomFeeInfo.prepayAmount > 0" style="color: #67C23A; margin-left: 15px;">
            | 本页{{ $t('simplifyRoomFee.prepayableTotal') }}{{ simplifyRoomFeeInfo.prepayAmount }}
        </span>
        </span>
      </el-col>
    </el-row>
    <!-- Modal Components -->
    <delete-fee ref="deleteFee" @success="handleNotify"></delete-fee>
    <edit-fee ref="editFee" @success="handleNotify"></edit-fee>
    <temp-import-room-fee ref="tempImportRoomFee" @success="handleNotify"></temp-import-room-fee>
    <room-create-fee-add ref="roomCreateFeeAdd" @success="handleNotify"></room-create-fee-add>
    <add-meter-water ref="addMeterWater" @success="handleNotify"></add-meter-water>
    <add-proxy-fee ref="addProxyFee" @success="handleNotify"></add-proxy-fee>
    <finish-fee ref="finishFee" @success="handleNotify"></finish-fee>
  </div>
</template>

<script>
import { listFee, listFeeConfigs, listMonthFee } from '@/api/fee/simplifyRoomFeeApi'
import { getDict } from '@/api/community/communityApi'
import { getCommunityId } from '@/api/community/communityApi'
import {finishBatchFee} from '@/api/fee/finishBatchFeeApi'
import {deleteBatchFee} from '@/api/fee/deleteBatchFeeApi'
//import { listFeeConfigs } from '@/api/fee/feeConfigManageApi'
import TempImportRoomFee from './tempImportRoomFee'
import { dateFormat } from '@/utils/dateUtil'
import DeleteFee from '@/components/fee/deleteFee'
import EditFee from '@/components/fee/editFee'
import RoomCreateFeeAdd from '@/components/fee/roomCreateFeeAdd'
import AddMeterWater from '@/components/fee/addMeterWater'
import AddProxyFee from '@/components/fee/addProxyFee'
import FinishFee from '@/components/fee/finishFee'

export default {
  name: 'SimplifyRoomFee',
  components: {
    TempImportRoomFee,
    DeleteFee,
    EditFee,
    RoomCreateFeeAdd,
    AddMeterWater,
    AddProxyFee,
    FinishFee
  },
  data() {
    return {
      simplifyRoomFeeInfo: {
        total: 0,
        records: 1,
        fees: [],
        monthFees: [],
        roomId: '',
        roomName: '',
        name: '',
        floorNum: '',
        unitNum: '',
        roomNum: '',
        configId: '',
        feeTypeCds: [],
        feeTypeCd: '',
        state: '2008001',
        totalAmount: 0.0,
        prepayAmount:0.0,  //create by cht at 17:50
        roomType: '',
        ownerFee: 'N',
        ownerId: '',
        showFlag: 'DEFAULT',
        feeConfigs: []
      },
      currentPage: 1,
      pageSize: 10,
      groupedFees: [],              // 分组后的费用数据(新增)  create by cht at 2026/6/9 16:40
      expandedGroups: {},           // 各分组的展开状态 { configId: boolean }(新增)   create by cht at 2026/6/9 16:40
      displayMode: '1',             // 展示模式：1=平铺(默认)，2=分组  create by cht at 2026/6/10 10:15
      flatSelectedFeeIds: [],       // 平铺模式：选中的 feeId 数组    create by cht at 2026/6/13 9:45
      groupSelectedConfigIds: [],   // 分组模式：选中的 configId 数组(费用项级别)    create by cht at 2026/6/13 9:45
      groupSelectedFeeIds: {},      // 分组模式：各组内选中的 feeId { configId: [feeId1, feeId2] }   create by cht at 2026/6/13 9:45
      total: 0
    }
  },
  computed: {
    filteredFeeTypeCds() {
      return this.simplifyRoomFeeInfo.feeTypeCds.filter(item => item.statusCd !== '888800010008')
    },
    // 新增：统计不同的费用项数量  create by cht at 2026/6/10 10:55
    uniqueFeeCount() {
      return new Set(this.simplifyRoomFeeInfo.fees.map(fee => fee.configId)).size
    },
    // 是否有批量选择    create by cht at 2026/6/13 10:10
    hasBatchSelection() {
      if (this.displayMode === '1') {
        return this.flatSelectedFeeIds.length > 0
      } else {
        return this.groupSelectedConfigIds.length > 0 ||
            Object.values(this.groupSelectedFeeIds).some(arr => arr.length > 0)
      }
    }
  },
  created() {
    this.communityId = getCommunityId()
    //this.loadDictData()
    //新增2行  记忆用户选择：刷新页面后保持上次的选择 create by cht at 2026/6/10 10:20
    const saved = localStorage.getItem('roomFeeDisplayMode')
    if (saved) this.displayMode = saved
  },
  watch: {//刷新页面后保持上次的选择   create by cht at 2026/6/10 10:20
    displayMode(val) {
      localStorage.setItem('roomFeeDisplayMode', val)
      this.clearSelection()  //create by cht at 2026/6/13 10:20
      // 新增：切换到分组模式时，确保分组数据已计算
      if (val === '2' && this.groupedFees.length === 0) {
        this.groupedFees = this.groupFeesByConfig(this.simplifyRoomFeeInfo.fees)
        this.expandAllGroups()
      }
    }
  },
  methods: {
    open(params) {
      this.handleSwitch(params)
    },
    handleSwitch(param) {
      this.clearSimplifyRoomFeeInfo()
      if (param.roomId === '') return

      Object.assign(this.simplifyRoomFeeInfo, param)
      this.listSimplifyRoomFee(1, this.pageSize)

      getDict('pay_fee_config', 'fee_type_cd').then(data => {
        this.simplifyRoomFeeInfo.feeTypeCds = data
      })
    },
    handleNotify() {
      this.listSimplifyRoomFee(this.currentPage, this.pageSize)
    },
    getOnePrice1(fee) {
      let price = fee.mwPrice
      if (!price) return fee.squarePrice
      if (parseFloat(price) > 0) return price
      return fee.squarePrice
    },
    handleFlatSelectionChange(selection) {//平铺展示---复选框收集feeIds方法   create by cht at 2026/6/13 9:50
      this.flatSelectedFeeIds = selection.map(row => row.feeId)
    },
    // (分组展示)勾选/取消勾选费用项(configId级别)  create by cht at 2026/6/13 10:00
    toggleGroupConfig(configId, checked) {
      if (checked) {
        // 添加 configId
        if (!this.groupSelectedConfigIds.includes(configId)) {
          this.groupSelectedConfigIds.push(configId)
        }
        // 自动勾选该组内所有行
        this.$nextTick(() => {
          const table = this.$refs['groupTable_' + configId]
          if (table && table[0]) {
            table[0].toggleAllSelection()
          }
        })
      } else {
        this.groupSelectedConfigIds = this.groupSelectedConfigIds.filter(id => id !== configId)
        // 取消该组内所有行
        this.$nextTick(() => {
          const table = this.$refs['groupTable_' + configId]
          if (table && table[0]) {
            table[0].clearSelection()
          }
        })
      }
    },
    // (分组展示)组内行选择变化    create by cht at 2026/6/13 10:00
    handleGroupFeeSelection(configId, selection) {
      const feeIds = selection.map(row => row.feeId)
      this.$set(this.groupSelectedFeeIds, configId, feeIds)
    },

    async listSimplifyRoomFee(page, row) {
      const params = {
        page,
        row,
        communityId: getCommunityId(),
        payerObjId: this.simplifyRoomFeeInfo.roomId,
        payerObjType: '3333',
        configId: this.simplifyRoomFeeInfo.configId,
        state: this.simplifyRoomFeeInfo.state,
        feeTypeCd: this.simplifyRoomFeeInfo.feeTypeCd
      }

      if (this.simplifyRoomFeeInfo.ownerFee === 'Y') {
        params.payerObjId = ''
        params.ownerId = this.simplifyRoomFeeInfo.ownerId
      }

      try {
        const res = await listFee(params)
        this.simplifyRoomFeeInfo.total = res.total
        this.simplifyRoomFeeInfo.records = res.records
        let totalAmount = res.totalAmount || 0      // 新增注释:欠费金额(截止到本月) create by cht at 2026/6/10 17:30
        let prepayAmount = res.prepayAmount || 0    // 预交金额(未来月份)  create by cht at 2026/6/10 17:30

        // 默认智能判断:只在首次访问且没有本地缓存时触发,即首次进入时根据数据量自动选择  create by cht at 2026/6/10  10:20
        if (res.fees.length === 0) {//没有数据的平铺，有数据的使用本地存储的展示方式
          this.displayMode = '1'
          localStorage.removeItem('roomFeeDisplayMode')
        } else if (!localStorage.getItem('roomFeeDisplayMode')) {
          const configIdSet = new Set(res.fees.map(f => f.configId))
          this.displayMode = configIdSet.size < res.fees.length ? '2' : '1'
        }

        // res.fees.forEach(item => {
        //   // const feeEndTime = new Date(item.endTime)  // 账单结束时间 create by cht at 2026/6/10 17:30
        //   // if (feeEndTime <= currentMonth) {
        //   //   // 截止到本月的账单 = 欠费
        //   //   totalAmount += parseFloat(item.amountOwed)
        //   // } else {
        //   //   // 未来账单 = 预交
        //   //   prepayAmount += parseFloat(item.amountOwed)
        //   // }
        //   totalAmount += parseFloat(item.amountOwed)
        // })

        this.simplifyRoomFeeInfo.totalAmount = totalAmount.toFixed(2)
        this.simplifyRoomFeeInfo.prepayAmount = prepayAmount.toFixed(2)  // create by cht at 2026/6/10 17:30
        // this.simplifyRoomFeeInfo.fees = res.fees.sort(this.roomFeeCompare)
        this.simplifyRoomFeeInfo.fees = res.fees
        if (this.displayMode === '2') {//create by cht at 2026/6/10 10:40
          // 按费用项分组(新增)
          this.groupedFees = this.groupFeesByConfig(this.simplifyRoomFeeInfo.fees)
          // 默认全部展开(新增)
          this.expandAllGroups()
        }
        this.total = res.total
        /*================================翻页后恢复选中状态 create by cht at 2026/6/13 16:35=========================================*/
        this.$nextTick(() => {
          if (this.displayMode === '1') {
            // 平铺模式：恢复 feeIds 选中
            if (this.$refs.flatTable && this.flatSelectedFeeIds.length > 0) {
              this.simplifyRoomFeeInfo.fees.forEach(row => {
                if (this.flatSelectedFeeIds.includes(row.feeId)) {
                  this.$refs.flatTable.toggleRowSelection(row, true)
                }
              })
            }
          } else if (this.displayMode === '2') {
            // 分组模式：恢复 configIds 和 feeIds 选中
            this.groupedFees.forEach(group => {
              const configId = group.configId
              const table = this.$refs['groupTable_' + configId]
              if (!table || !table[0]) return

              if (this.groupSelectedConfigIds.includes(configId)) {
                table[0].toggleAllSelection()
              } else if (this.groupSelectedFeeIds[configId] && this.groupSelectedFeeIds[configId].length > 0) {
                const feeIds = this.groupSelectedFeeIds[configId]
                group.fees.forEach(row => {
                  if (feeIds.includes(row.feeId)) {
                    table[0].toggleRowSelection(row, true)
                  }
                })
              }
            })
          }
        /*================================create by cht at 2026/6/13 16:35=========================================*/
        })
      } catch (error) {
        console.error('Failed to fetch fee list:', error)
      }
    },
    roomFeeCompare(a, b) {
      if (a.payerObjName < b.payerObjName) return -1
      if (a.payerObjName > b.payerObjName) return 1
      return 0
    },
    toOwnerPayFee() {
      this.$router.push({
        path: '/views/fee/owePayFeeOrder',
        query: {
          payObjId: this.simplifyRoomFeeInfo.roomId,
          payObjType: '3333',
          roomName: this.simplifyRoomFeeInfo.roomName
        }
      })
    },
    openRoomCreateFeeAddModal() {
      this.simplifyRoomFeeInfo.ownerName = this.simplifyRoomFeeInfo.name
      this.$refs.roomCreateFeeAdd.open({
        isMore: false,
        roomId: this.simplifyRoomFeeInfo.roomId,
        roomName: this.simplifyRoomFeeInfo.roomName,
        ownerName: this.simplifyRoomFeeInfo.name
      })
    },
    openAddMeterWaterSimplifyModal() {
      this.$refs.addMeterWater.open({
        roomId: this.simplifyRoomFeeInfo.roomId,
        roomName: this.simplifyRoomFeeInfo.roomName,
        ownerName: this.simplifyRoomFeeInfo.name
      });
    },
    getAttrValue(attrs, specCd) {
      const attr = attrs.find(item => item.specCd === specCd)
      return attr ? attr.value : ""
    },
    getDeadlineTime(fee) {
      if (fee.amountOwed == 0 && fee.endTime == fee.deadlineTime) return "-"
      if (fee.state == '2009001') return "-"
      return dateFormat(fee.deadlineTime)
    },
    getEndTime(fee) {
      if (fee.state == '2009001') return "-"
      return dateFormat(fee.endTime)
    },
    openProxyFeeModal() {
      this.$refs.addProxyFee.open({
        roomId: this.simplifyRoomFeeInfo.roomId,
        roomName: this.simplifyRoomFeeInfo.roomName,
        ownerName: this.simplifyRoomFeeInfo.name
      })
    },
    payFee(fee) {
      fee.roomName = this.simplifyRoomFeeInfo.roomName
      fee.builtUpArea = this.simplifyRoomFeeInfo.builtUpArea
      this.$router.push({
        path: '/views/fee/payFeeOrder',
        query: { feeId: fee.feeId }
      })
    },
    editFee(fee) {
      fee.maxEndTime = this.getAttrValue(fee.feeAttrs, '390010')
      this.$refs.editFee.open(fee)
    },
    payFeeHis(fee) {
      fee.builtUpArea = this.simplifyRoomFeeInfo.builtUpArea
      this.$router.push({
        path: '/views/fee/propertyFee',
        query: fee
      })
    },
    deleteFee(fee) {
      this.$refs.deleteFee.open({
        communityId: getCommunityId(),
        feeId: fee.feeId
      })
    },
    finishFee(fee) {
      this.$refs.finishFee.open({
        communityId: getCommunityId(),
        feeId: fee.feeId
      })
    },
    openTempImportRoomFeeModal() {
      this.$refs.tempImportRoomFee.open({
        roomId: this.simplifyRoomFeeInfo.roomId,
        roomName: this.simplifyRoomFeeInfo.roomName,
        ownerName: this.simplifyRoomFeeInfo.name
      })
    },
    clearSimplifyRoomFeeInfo() {
      const feeConfigs = this.simplifyRoomFeeInfo.feeConfigs
      this.simplifyRoomFeeInfo = {
        total: 0,
        records: 1,
        fees: [],
        monthFees: [],
        accounts: [],
        roomId: '',
        name: '',
        roomName: '',
        floorNum: '',
        unitNum: '',
        roomNum: '',
        feeConfigs: feeConfigs,
        feeTypeCd: '',
        configId: '',
        state: '2008001',
        totalAmount: 0.0,
        prepayAmount: 0.0,  //新增预缴费计费字段  create by cht at 2026/6/10 18:10
        roomType: '',
        ownerFee: 'N',
        ownerId: '',
        showFlag: 'DEFAULT'
      }
      // 重置分组  create by cht at 2026/6/9 16:50
      this.groupedFees = []
      this.expandedGroups = {}
      // 清空选择  create by cht at 2026/6/13 10:30
      this.flatSelectedFeeIds = []
      this.groupSelectedConfigIds = []
      this.groupSelectedFeeIds = {}
      if (this.$refs.flatTable) {
        this.$refs.flatTable.clearSelection()
      }
    },
    changeSimplifyRoomFeeFeeTypeCd(feeTypeCd) {
      this.simplifyRoomFeeInfo.configId = ''
      this.$emit('notify', {})

      const params = {
        page: 1,
        row: 50,
        communityId: getCommunityId(),
        feeTypeCd: feeTypeCd,
        isDefault: '',
        valid: '1'
      }

      listFeeConfigs(params).then(res => {
        this.simplifyRoomFeeInfo.feeConfigs = res.feeConfigs
      }).catch(error => {
        console.error('Failed to fetch fee configs:', error)
      })
    },
    changeSimplifyRoomConfigId() {
      this.handleNotify()
      this.$emit('notify', {})
    },
    simplifyRoomGetFeeOwnerInfo(attrs) {
      const ownerName = this.getAttrValue(attrs, '390008')
      const ownerLink = this.getAttrValue(attrs, '390009')
      return `业主：${ownerName},电话：${ownerLink}`
    },
    getSimplifyRoomFeeRoomName(fee) {
      if (this.simplifyRoomFeeInfo.ownerFee != 'Y') return ''

      const attr = fee.feeAttrs.find(item => item.specCd === '390012')
      return attr ? `(${attr.value})` : ''
    },
    openBatchPayRoomFeeModal() {
      this.$router.push({
        path: '/views/fee/batchPayFeeOrder',
        query: {
          ownerId: this.simplifyRoomFeeInfo.ownerId,
          payerObjId: this.simplifyRoomFeeInfo.roomId,     // create by cht at 2026/7/8 15:15
          payerObjType: '3333'
        }
      })
    },
    openMonthPayRoomFeeModal() {
      this.$router.push({
        path: '/property/payFeeMonthOrder',
        query: {
          payerObjId: this.simplifyRoomFeeInfo.roomId,
          payerObjType: '3333'
        }
      })
    },
    openRoomCreateFeeComboModal() {
      this.$router.push({
        path: '/views/fee/createFeeByCombo',
        query: {
          payerObjId: this.simplifyRoomFeeInfo.roomId,
          payerObjName: this.simplifyRoomFeeInfo.roomName,
          payerObjType: '3333'
        }
      })
    },
    viewRoomFeeConfig(fee) {
      const params = {
        page: 1,
        row: 1,
        communityId: getCommunityId(),
        configId: fee.configId
      }

      listFeeConfigs(params).then(res => {
        const feeConfig = res.feeConfigs[0]
        this.$emit('openViewDataModal', {
          title: `${fee.feeName} 费用项`,
          data: {
            "费用项ID": feeConfig.configId,
            "费用类型": feeConfig.feeTypeCdName,
            "收费项目": feeConfig.feeName,
            "费用标识": feeConfig.feeFlagName,
            "催缴类型": feeConfig.billTypeName,
            "付费类型": feeConfig.paymentCd == '1200' ? '预付费' : '后付费',
            "缴费周期": feeConfig.paymentCycle,
            "应收开始时间": feeConfig.startTime,
            "应收结束时间": feeConfig.endTime,
            "公式": feeConfig.computingFormulaName,
            "计费单价": feeConfig.computingFormula == '2002' ? '-' : feeConfig.squarePrice,
            "附加/固定费用": feeConfig.additionalAmount
          }
        })
      }).catch(error => {
        console.error('Failed to fetch fee config:', error)
      })
    },
    viewRoomFee(fee) {
      const data = {
        "费用ID": fee.feeId,
        "费用标识": fee.feeFlagName,
        "费用类型": fee.feeTypeCdName,
        "付费对象": fee.payerObjName,
        "费用项": fee.feeName,
        "费用状态": fee.stateName,
        "建账时间": fee.startTime,
        "应收开始时间": this.getEndTime(fee),
        "应收结束时间": this.getDeadlineTime(fee),
        "批次": fee.batchId
      }

      fee.feeAttrs.forEach(attr => {
        data[attr.specCdName] = attr.value
      })

      this.$emit('openViewDataModal', {
        title: `${fee.feeName} 详情`,
        data: data
      })
    },
    changeSimplifyRoomShowFlag() {
      if (this.simplifyRoomFeeInfo.showFlag == 'MONTH') {
        this.listSimplifyRoomMonthFee(1, this.pageSize)
      } else {
        this.listSimplifyRoomFee(1, this.pageSize)
      }
    },
    async listSimplifyRoomMonthFee(page, row) {
      const params = {
        page,
        row,
        communityId: getCommunityId(),
        objId: this.simplifyRoomFeeInfo.roomId,
        payerObjType: '3333',
        configId: this.simplifyRoomFeeInfo.configId,
        feeTypeCd: this.simplifyRoomFeeInfo.feeTypeCd,
        detailId: '-1',
        feeState: '2008001'
      }

      if (this.simplifyRoomFeeInfo.ownerFee == 'Y') {
        params.payerObjId = ''
        params.ownerId = this.simplifyRoomFeeInfo.ownerId
      }

      try {
        const res = await listMonthFee(params)
        this.simplifyRoomFeeInfo.total = res.total
        this.simplifyRoomFeeInfo.records = res.records
        let totalAmount = 0.0

        res.data.forEach(item => {
          totalAmount += parseFloat(item.receivableAmount)
        })

        this.simplifyRoomFeeInfo.totalAmount = totalAmount.toFixed(2)
        this.simplifyRoomFeeInfo.monthFees = res.data
      } catch (error) {
        console.error('Failed to fetch month fee list:', error)
      }
    },
    handleCurrentChange(page) {
      this.currentPage = page
      if (this.simplifyRoomFeeInfo.showFlag == 'MONTH') {
        this.listSimplifyRoomMonthFee(page, this.pageSize)
      } else {
        // this.clearSelection()  //create by cht at 2026/6/13 10:20
        this.listSimplifyRoomFee(page, this.pageSize)
      }
    },
    clearSelection() { //清空复选框选项
      this.flatSelectedFeeIds = []
      this.groupSelectedConfigIds = []
      this.groupSelectedFeeIds = {}
      if (this.$refs.flatTable) this.$refs.flatTable.clearSelection()
      // 分组表格清空...
    },
    // 其他方法类似
    /**
     * 将费用列表按 configId 分组  create by cht at 2026/6/9 16:40
     */
    groupFeesByConfig(fees) {
      const groupMap = {};
      const now = new Date();
      const currentMonth = new Date(now.getFullYear(), now.getMonth(), 1);   //本月1号
      const nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);  // 下月1号

      fees.forEach(fee => {
        const key = fee.configId;

        const feeEndTime = new Date(fee.deadlineTime);
        // 判断预付费/后付费,1200=预付费，2100=后付费
        const isPrepay = fee.paymentCd === '1200';
        // 预付费用下月1号，后付费用本月1号
        const targetDate = isPrepay ? nextMonth : currentMonth;
        const isArrears = feeEndTime <= targetDate; // true=欠费, false=预缴

        if (!groupMap[key]) {
          groupMap[key] = {
            configId: key,
            feeName: fee.feeName,
            feeFlagName: fee.feeFlagName,
            feeTypeCdName: fee.feeTypeCdName,
            totalAmount: 0,      // 欠费合计
            prepayAmount: 0,     // 预交合计(新增)
            count: 0,
            fees: []
          };
        }
        groupMap[key].fees.push(fee);
        if (isArrears) {
          groupMap[key].totalAmount += parseFloat(fee.amountOwed || 0);
        } else {
          groupMap[key].prepayAmount += parseFloat(fee.amountOwed || 0);
        }
        groupMap[key].count++;
      });

      // 转换为数组并排序(保持原有排序)
      return Object.values(groupMap);
    },

    /**
     * 切换分组的展开/收起状态
     */
    toggleGroup(configId) {
      this.$set(this.expandedGroups, configId, !this.expandedGroups[configId]);
    },

    /**
     * 判断分组是否展开(默认展开)
     */
    isGroupExpanded(configId) {
      return this.expandedGroups[configId] !== false;
    },

    /**
     * 展开所有分组
     */
    expandAllGroups() {
      this.groupedFees.forEach(group => {
        this.$set(this.expandedGroups, group.configId, true);
      });
    },

    /**
     * 收起所有分组
     */
    collapseAllGroups() {
      this.groupedFees.forEach(group => {
        this.$set(this.expandedGroups, group.configId, false);
      });
    },
    // 批量取消 create by cht at 2026/6/13 10:15
    batchDeleteFee() {
      const params = {
        communityId: getCommunityId()
      }

      if (this.displayMode === '1') {
        // 平铺模式传 feeIds
        params.feeIds = this.flatSelectedFeeIds.join(',')
      } else {
        // 分组模式优先判断 configIds
        if (this.groupSelectedConfigIds.length > 0) {
          params.configIds = this.groupSelectedConfigIds.join(',')
          params.payerObjId = this.simplifyRoomFeeInfo.roomId
        } else {
          // 收集所有组内选中的 feeIds
          const feeIds = []
          Object.values(this.groupSelectedFeeIds).forEach(arr => feeIds.push(...arr))
          params.feeIds = [...new Set(feeIds)].join(',')
        }
      }

      // 调用后端接口
      this.$confirm('确定批量取消选中的费用？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteBatchFee(params).then(() => {
          this.$message.success('批量取消成功')
          this.clearSelection()
          this.handleNotify()
        }).catch(error => {
          this.$message.error(error.message || error || '批量取消失败')
        })
      }).catch(() => {
        // 用户取消
      })
    },

    // 批量结束
    batchFinishFee() {
      const params = {
        communityId: getCommunityId()
      }

      if (this.displayMode === '1') {
        params.feeIds = this.flatSelectedFeeIds.join(',')
      } else {
        if (this.groupSelectedConfigIds.length > 0) {
          params.configIds = this.groupSelectedConfigIds.join(',')
          params.payerObjId = this.simplifyRoomFeeInfo.roomId
        } else {
          const feeIds = []
          Object.values(this.groupSelectedFeeIds).forEach(arr => feeIds.push(...arr))
          params.feeIds = [...new Set(feeIds)].join(',')
        }
      }

      this.$confirm('确定批量结束选中的费用？结束后无法重新启用，请谨慎操作！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        finishBatchFee(params).then(() => {
          this.$message.success('批量结束成功')
          this.clearSelection()
          this.handleNotify()
        }).catch(error => {
          this.$message.error(error.message || error || '批量结束失败')
        })
      }).catch(() => {
        // 用户取消
      })
    }
    /*=============by cht at 2026/6/13 10:15===================*/
  }
}
</script>

<style scoped>
.margin-top-lg {
  margin-top: 20px;
}

.margin-top {
  margin-top: 15px;
}

.text-right {
  text-align: right;
}

.hand {
  cursor: pointer;
}

/* ———————— 新增样式 create by cht at 2026/6/9 16:40 —————— */
.margin-bottom {
  margin-bottom: 15px;
}

.margin-left {
  margin-left: 15px;
}
.flex {
  display: flex;
}

.align-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

/* ========== 费用统计 ========== */
.fee-summary {
  margin-left: 15px;
  color: #909399;
  font-size: 14px;
}

/* ========== 分组列表 ========== */
.fee-group-list {
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.fee-group {
  border-bottom: 1px solid #ebeef5;
}

.fee-group:last-child {
  border-bottom: none;
}

/* ========== 分组标题行 ========== */
.fee-group-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 15px;
  background-color: #f5f7fa;
  cursor: pointer;
  transition: background-color 0.3s;
}

.fee-group-header:hover {
  background-color: #e8f4ff;
}

.fee-group-header.expanded {
  background-color: #ecf5ff;
}

/* 左侧区域 */
.fee-group-header .flex {
  flex-shrink: 0;
  align-items: center;
}

/* 复选框 */
.fee-group-header .el-checkbox {
  margin-bottom: 0;
  height: 14px;
}

/* 费用项ID */
.fee-group-id {
  font-size: 14px;
  line-height: 1;
  color: #606266;
  margin-left: 6px;
}

/* 费用项名称 */
.fee-group-name {
  font-size: 14px;
  line-height: 1;
  font-weight: bold;
  color: #303133;
  margin-left: 2px;  /* 跟ID的间距 */
}

/* 中间统计信息 */
.fee-group-meta {
  flex: 1;
  text-align: center;
  color: #606266;
  font-size: 13px;
  margin: 0 20px;
}

/* 右侧箭头 */
.expand-icon {
  flex-shrink: 0;
  font-size: 14px;
  color: #909399;
  margin-left: 15px;
  transition: transform 0.3s;
}

/* ========== 分组内容 ========== */
.fee-group-content {
  padding: 10px;
  background-color: #fff;
}
/*========== create by cht at 2026/6/13 16:05 ==========*/

</style>
